import React from "react";

const GuideSocialLinksFormGroup = (props) => {

    const removeObjectsWithEmptyValues = (objectArray) => {
        return objectArray.filter(obj => obj.url !=="")
    }

    const handleAddSocial = (e) => {
        e.preventDefault()
        const newArr = [...props.social_links]
        newArr.push({platform:"", link:""})
        props.setSocialLinks(newArr)
    }

    const handleSocialsUpdate = (key, index, value) => {
        let objects = [...props.social_links]
        objects[index][key] = value
        props.setSocialLinks(removeObjectsWithEmptyValues(objects))
    }

    return (    
       <div className="form-group">
            <label>Social Links</label>
                <div className="form-group obj-group">
                    {props.social_links && props.social_links.length > 0 && props.social_links.map((link, i)=>(
                        <div key={`social-link-${i}`} className="form-group inline">
                            <div className="form-group">
                                {i == 0 && (<small>Platform</small>)}
                                <select name="platform" value={props.social_links[i].platform} onChange={(e) => handleSocialsUpdate('platform',i, e.target.value)}>
                                    <option value="">Select Platform</option>
                                    <option value="Instagram">Instagram</option>
                                    <option value="TikTok">TikTok</option>
                                    <option value="Threads">Threads</option>
                                    <option value="LinkedIn">LinkedIn</option>
                                    <option value="YouTube">YouTube</option>
                                    <option value="Website">Website</option>
                                </select>
                            </div>
                            <div className="form-group">
                                {i == 0 && (<small>Url</small>)}
                                <input type="text" value={link.url} onChange={(e) => handleSocialsUpdate('url',i, e.target.value)}/>
                            </div>
                        </div>
                    ))}
                <button className="manage-item-action add-input" onClick={handleAddSocial}>+</button>
            </div>
        </div>
    )
}

export default GuideSocialLinksFormGroup;